var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-margin-left page-margin-top"},[_c('v-card',[_c('Header',{attrs:{"headerTitle":"Credit Transactions","hasMenu":_vm.hasMenu}}),_c('CreditTransactionsTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }